module.exports = __webpack_public_path__ + "img/AlertIcon.fe4b0ae4.svg";